/**
 * PMS RPC Module
 *
 * Wraps Supabase RPC calls so the raw client
 * is never imported outside `src/integrations/pms/`.
 */

import { supabase } from '@/integrations/supabase/client';

/**
 * Call a database function via RPC.
 *
 * @example
 *   const result = await pmsRpc('add_ai_credits', { p_user_id: userId, p_amount: 100 });
 */
export async function pmsRpc<T = any>(
  functionName: string,
  params?: Record<string, unknown>,
): Promise<T> {
  const { data, error } = await supabase.rpc(functionName as any, params as any);
  if (error) throw error;
  return data as T;
}
